import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Row, Col, Container } from 'react-bootstrap'
import PesoTalla1 from '../PesoTalla/PesoTalla1.jpg'
import PesoTalla2 from '../PesoTalla/PesoTalla2.jpg'
import PesoTalla3 from '../PesoTalla/PesoTalla3.jpg'
import PesoTalla4 from '../PesoTalla/PesoTalla4.jpg'

export class Weight extends Component {
    render() {
        const weightItems = [
            { img: PesoTalla1, title: "Stadiometer / Infantometer" },
            { img: PesoTalla2, title: "Stadiometer / Infantometer" },
            { img: PesoTalla3, title: "Pediatric Scale" },
            { img: PesoTalla4, title: "Adult Scale and Floor Scale" }
        ];

        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Weight and Height</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Usamos el estándar de 2 columnas para imágenes con texto y escalas de medición */}
                    <Row className="justify-content-center g-4">
                        {weightItems.map((item, idx) => (
                            <Col key={idx} xs={12} lg={6}>
                                <Card className="shadow-sm border-0 text-center h-100">
                                    <Card.Body className="p-3">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ width: '100%', height: 'auto', objectFit: 'contain' }} 
                                        />
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.4rem' }}>{item.title}</Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}